import { Tag as ChordsTag } from '~/chords/Tag';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const Tag = withClassNameHoc(ChordsTag);
